import { useLocation } from 'react-router-dom';

export default function StickyMobileBar() {
  const location = useLocation();
  const isMerci = location.pathname === '/merci';
  const isNotFound = location.pathname === '/404' || location.pathname === '*' || !location.pathname;

  // Masquer sur les pages merci et 404
  if (isMerci || isNotFound) return null;

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const handleQuoteClick = () => {
    const currentPath = location.pathname;
    if (
      currentPath === '/' ||
      currentPath === '/bardeau-asphalte' ||
      currentPath === '/inspection-toiture' ||
      currentPath === '/deneigement-toiture' ||
      currentPath === '/soumission-gratuite'
    ) {
      const el = document.getElementById('quote-form');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigateTo('/soumission-gratuite');
      }
    } else {
      navigateTo('/soumission-gratuite');
    }
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-soft-dark shadow-[0_-4px_12px_rgba(0,0,0,0.08)] flex"
      aria-label="Barre d'action mobile"
    >
      <a
        href="tel:+14184769950"
        aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
        title="Cliquez pour appeler"
        className="flex-1 flex items-center justify-center gap-2 bg-slate-primary hover:bg-slate-dark text-white font-semibold text-sm py-3.5 transition-colors whitespace-nowrap"
      >
        <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20">
          <i className="ri-phone-line text-sm" />
        </span>
        Appeler
      </a>
      <button
        onClick={handleQuoteClick}
        className="flex-1 flex items-center justify-center gap-2 bg-copper hover:bg-copper-dark text-white font-semibold text-sm py-3.5 transition-colors whitespace-nowrap cursor-pointer"
      >
        <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/20">
          <i className="ri-file-list-3-line text-sm" />
        </span>
        Soumission
      </button>
    </div>
  );
}